// extracted by mini-css-extract-plugin
export var carrierNotice = "_lu-5";
export var carrierNoticePlaceholder = "_lu-6";
export var deliveryRow = "_lu-c";
export var fixedHeight = "_lu-4";
export var freightLogo = "_lu-b";
export var fullWidth = "_lu-3";
export var priceColumn = "_lu-7";
export var radioSelected = "_lu-9";
export var radioUnselected = "_lu-8";
export var selectedOption = "_lu-2";
export var selectedOptionContainer = "_lu-1";
export var selection = "_lu-0";
export var tallSkeletonText = "_lu-a";